import React from "react"
import { IMainLayoutTypes } from "./MainLayoutTypes"
import { Box, Container, Flex, Image, Text } from "@chakra-ui/react"
import { useLocation } from "react-router-dom"

import { getItemFromLocalStorage } from "utils/localStorage"
import BGArc from "assets/img/main-bg-arc.png"
import BdsLogo from "assets/img/bds-logo.png"

import QappLogo from "components/UI/atoms/QappLogo"
import Navigation from "components/shared/Navigation"
import CompanyProfile from "components/shared/CompanyProfile"
import LanguageSwitcher from "components/shared/LanguageSwitcher"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IRoles } from "types/shared"

export const MainLayout: React.FC<IMainLayoutTypes> = ({
  children,
  navigation,
}) => {
  const token = getItemFromLocalStorage("token")

  const { pathname } = useLocation()


  const { isAuthenticated, userRole } = useAppContext()
  if (isAuthenticated && userRole && userRole === IRoles.WASHER_MANAGER && (pathname !== "/dashboard" && !pathname.includes("reservations"))) {
    window.location.href = "/";
  }

  const regex = /^\/laundry\/\d+\/change_history$/;



  return (
    <Box
      pos="relative"
      mr={"unset"}
      w={"100%"}
      minHeight={"100vh"}
      overflow="hidden"
      zIndex={2}
    >
      <Box
        pos="absolute"
        width="100%"
        height="100%"
        background="main_bg"
        opacity={0.2}
        zIndex={-1}
      />

      <Box pos="absolute" left={-192} bottom={-400} zIndex={-1}>
        <Image alt="Background Arc" src={BGArc} />
      </Box>
      <Box pos="absolute" right={-500} top={-300} zIndex={-1}>
        <Image alt="Background Arc" src={BGArc} />
      </Box>
      <Container
        maxWidth="100%"
        width={{ xl: "container_xl", lg: "container_lg", sm: "container_base" }}
      >
        <Box maxWidth={"1160px"} width={"100%"}>
          <Flex
            padding="25px 0"
            justifyContent="space-between"
            alignItems="flex-start"
            height="120px"
          >
            <Box>{token && <CompanyProfile />}</Box>
            {navigation ? <Navigation /> : <QappLogo />}
            <LanguageSwitcher />
          </Flex>
          {children}
        </Box>
      </Container>
      {["/dashboard", "/login", "/reports",
        "/settings/bookings",
        "/settings/cancellation_fee"].includes(pathname) && <>
          <Text style={{
            opacity: "50%",
            fontSize: "11px",
            position: "absolute",
            left: "47.5%",
            transform: "translateX(-50%)",
            whiteSpace: "nowrap",
            bottom: "0.7%"
          }}>
            {"Powered by"}
          </Text>
          <a target='_blank'
            rel='noopener noreferrer' href="https://bds.ge">
            <Image alt="BDS Logo" src={BdsLogo} height="14px" style={{ bottom: "0.8%", left: window.innerWidth > 1200 ? "50.8%" : "53.5%", position: "absolute" }} />
          </a>
        </>
      }
      {regex.test(pathname) && <>
        <Text style={{
          opacity: "50%",
          fontSize: "11px",
          position: "absolute",
          left: "47.5%",
          transform: "translateX(-50%)",
          whiteSpace: "nowrap",
          bottom: "0.7%"
        }}>
          {"Powered by"}
        </Text>
        <a target='_blank'
          rel='noopener noreferrer' href="https://bds.ge">
          <Image alt="BDS Logo" src={BdsLogo} height="14px" style={{ bottom: "0.8%", left: window.innerWidth > 1200 ? "50.8%" : "53.5%", position: "absolute" }} />
        </a>
      </>}
      {["/settings",].includes(pathname) && <>
        <Text style={{
          opacity: "50%",
          fontSize: "11px",
          position: "absolute",
          left: "48%",
          transform: "translateX(-50%)",
          whiteSpace: "nowrap",
          bottom: "14.9%"
        }}>
          {"Powered by"}
        </Text>
        <a target='_blank'
          rel='noopener noreferrer' href="https://bds.ge">
          <Image alt="BDS Logo" src={BdsLogo} height="14px" style={{ bottom: "15.15%", left: window.innerWidth > 1200 ? "50.8%" : "52.5%", position: "absolute" }} />
        </a>
      </>
      }
      {["/settings/booking_fee",].includes(pathname) && <>
        <Text style={{
          opacity: "50%",
          fontSize: "11px",
          position: "absolute",
          left: "48%",
          transform: "translateX(-50%)",
          whiteSpace: "nowrap",
          bottom: "5%"
        }}>
          {"Powered by"}
        </Text>
        <a target='_blank'
          rel='noopener noreferrer' href="https://bds.ge">
          <Image alt="BDS Logo" src={BdsLogo} height="14px" style={{ bottom: "5.15%", left: window.innerWidth > 1200 ? "50.8%" : "52.5%", position: "absolute" }} />
        </a>
      </>
      }

    </Box>
  )
}

export default MainLayout
